import { API, APICall } from '../Api'

export default {
  name: 'Counties',

  methods: {
    async get (id) {
      const Request = {
        Type    : APICall.County.Get.Type,
        Endpoint: APICall.County.Get.Endpoint.replace('{id}', id),
        Data    : {}
      }
      return await API[Request.Type](Request.Endpoint, Request.Data)
    },

    async save (data) {
      if (typeof this.clearServerErrorMessages === 'function') this.clearServerErrorMessages()
      const Request = {
        Type    : APICall.County.Save.Type,
        Endpoint: APICall.County.Save.Endpoint,
        Data    : data
      }
      return await API[Request.Type](Request.Endpoint, Request.Data)
    },

    async all (data) {
      const Request = {
        Type    : APICall.County.List.Type,
        Endpoint: APICall.County.List.Endpoint,
        Data    : data || this.requestData()
      }
      return await API[Request.Type](Request.Endpoint, Request.Data)
    }

  }

}
